<template>
    <div id="form-container" ref="formContainer">
        <b-container fluid>
            <h1>
                Assign Credentialer
            </h1>
            <b-form class="mt-3">
                <b-row>
                    <BaseSelector v-model="asignee"
                                  :v="$v.asignee"
                                  slug="asignee"
                                  label="Credentialer"
                                  :options="credentialers"/>
                </b-row>
                <b-row class="mt-2">
                    <b-col cols="2">
                        <b-button type="button" variant="primary" @click="assign">Assign</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </b-container>
    </div>
</template>

<script>
import axios from "axios"
import axiosRetry from 'axios-retry'
import { required} from 'vuelidate/lib/validators'
import {toastService} from "@/mixins/toastService"
import BaseSelector from "@/components/templates/input/BaseSelector"

axiosRetry(axios, { retries: 0,
    retryDelay: axiosRetry.exponentialDelay  })

export default {
    data: () => ({
        credentialers: [],
        asignee: null,
        id: null,
        type: null,
    }),
    components:{
        BaseSelector
    },
    validations() {
        return {
            asignee: { required },
        }
    },
    methods: {
        initialize() {
            this.id = this.$route.params.id
            this.type = this.$route.params.type
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/admin/credentialers`)
                .then(response => {
                    this.credentialers = response.data
                })
            let payload = {
                id: this.id,
                type: this.type,
            }
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/admin/current/`, payload)
                .then(response => {
                    if (response.data !== "") {
                        this.asignee = response.data
                    }
                })
        },
        assign() {
            this.$v.$touch()
            if (!this.$v.$invalid) {
                let payload = {
                    id: this.id,
                    assignedName: this.asignee,
                    type: this.type
                }
                axios.post(`${process.env.VUE_APP_API_BASE_URL}/admin/assign`, payload)
                    .then(response => {
                        toastService.showRootToast("Assigned", "Credentialer has been assigned.", "success", this.$root)
                    }) .catch(error => {
                        toastService.showRootToast("Error", "An error has occurred " , "danger", this.$root)
                    })
            }
        },
    },
    created() {
        this.initialize()
        document.title = "Assign Credentialer - NAR"
    },
    mixins: [
        toastService
    ],
}
</script>